import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import to from 'await-catch'
import moment from 'moment'
import styled from 'styled-components'
import theme from '../../../styled/theme'
import useIsMobile from '../../../hooks/useIsMobile'
import { Section, SectionHeader, SectionTitle } from '../../../styled/sections'
import { Text2 } from '../../../components/ui/text'
import { Button } from '../../../components/ui/button'
import ResultsListDesk from '../../../components/resultsListDesk'
import ResultsList from '../../../components/resultCard'
import { Text1 } from '../../../styled/generics'
import { searchAuditLogs, downloadLogList, getAuditActions } from '../../../api'
import { resetLabsFilters, setLabsFilters } from '../../../actions/filterLaboratory'
import { addFlashMessage, hideLoader, showLoader } from '../../../actions'
import { selectLabsFilters, selectLabsFiltersCount } from '../../../reducers/filterLaboratory'
import Pagination from '../../../components/pagination'
import { FormContainer } from '../../../components/ui/form'
import Input from '../../../components/ui/input'
import { Download, Filter } from '../../../assets/icons'
import { LOG_ACTION_LOGIN, SEARCH_DELAY_MS } from '../../../constants'
import LogActionsFilterModal from './LogActionsFilterModal'

const logsFields = [
	{ key: 'nombreApellidoUsuario', label: 'Usuario' },
	{ key: 'emailUsuario', label: 'Email' },
	{ key: 'fechaHora', label: 'Fecha' },
	{ key: 'nombreAccion', label: 'Acción' },
	{ key: 'descripcion', label: 'Log' }
]

function Logs({ filters, setLabsFilters, showLoader, hideLoader, addFlashMessage }) {
	const [showFiltersModal, setShowFiltersModal] = useState(false)
	const [auditActions, setAuditActions] = useState([])
	const [selectedFilters, setSelectedFilters] = useState([])
	const [searchText, setSearchText] = useState('')
	const isMobile = useIsMobile()
	const [dataList, setDataList] = useState([])
	const [pagination, setPagination] = useState({ totalPages: 1, currentPage: 1 })
	const [excelDownloading, setExcelDownloading] = useState(false)
	const [dates] = useState({
		startDate: moment().subtract(3, 'days'),
		endDate: moment()
	})
	const typingTimer = useRef(null)

	const handlePageChange = page => {
		setPagination(prev => ({ ...prev, currentPage: page }))
	}

	const handleOpenFilters = () => {
		setShowFiltersModal(true)
	}

	const handleSearch = event => {
		const inputValue = event.target.value || ''
		clearTimeout(typingTimer.current)
		typingTimer.current = setTimeout(() => {
			setPagination(prev => ({ ...prev, currentPage: 1 }))
			setSearchText(inputValue.trim())
		}, SEARCH_DELAY_MS)
	}

	const handleApplyFilters = actions => {
		const fallbackActions = auditActions
			.filter(item => item.key !== LOG_ACTION_LOGIN)
			.map(item => item.key)
		const safeActions = actions?.length ? actions : fallbackActions

		setSelectedFilters(safeActions)
		setPagination(prev => ({ ...prev, currentPage: 1 }))
		setShowFiltersModal(false)

		setLabsFilters({
			...filters,
			actions: safeActions
		})
	}

	const fetchData = async () => {
		try {
			showLoader()
			const [err, { data } = {}] = await to(
				searchAuditLogs({
					acciones: selectedFilters,
					busqueda: searchText,
					itemsPorPagina: 10,
					pagina: pagination.currentPage,
					totalPaginas: pagination.totalPages,
					fechaDesde: dates.startDate,
					fechaHasta: dates.endDate,
					items: []
				})
			)

			if (err) throw new Error('Error en el fetch de auditoría')

			setDataList(data?.items || [])
			setPagination(prev => ({
				...prev,
				totalPages: data?.totalPaginas || 1
			}))
		} catch (error) {
			addFlashMessage('Ocurrió un error cargando los registros de auditoría')
		} finally {
			hideLoader()
		}
	}

	const handleExportExcel = async () => {
		try {
			setExcelDownloading(true)
			const [err, { data } = {}] = await to(
				downloadLogList({
					acciones: selectedFilters,
					busqueda: searchText,
					fechaDesde: dates.startDate,
					fechaHasta: dates.endDate
				})
			)

			if (err) throw new Error('Error en la descarga')

			const blob = new Blob([data])
			const filename = `MiPortal_Logs_${new Date().getTime()}.xls`

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				link.href = window.URL.createObjectURL(blob)
				link.download = filename
				link.click()
			}
		} catch (error) {
			addFlashMessage('Ocurrió un error descargando los registros de auditoría')
		} finally {
			setExcelDownloading(false)
		}
	}

	useEffect(() => {
		const loadAuditActions = async () => {
			const [err, { data } = {}] = await to(getAuditActions())
			if (err || !Array.isArray(data)) {
				addFlashMessage('Ocurrió un error cargando las acciones de auditoría')
				return
			}

			const actions = data.map(action => ({ key: action.id, name: action.nombre }))
			const defaultActions = actions
				.filter(item => item.key !== LOG_ACTION_LOGIN)
				.map(item => item.key)

			setAuditActions(actions)
			setSelectedFilters(defaultActions)
		}

		loadAuditActions()
	}, [])

	useEffect(() => {
		if (!selectedFilters.length) {
			setDataList([])
			return
		}
		fetchData()
	}, [selectedFilters, pagination.currentPage, searchText])

	useEffect(() => {
		return () => clearTimeout(typingTimer.current)
	}, [])

	return (
		<div style={{ width: '100%' }}>
			<Section gap="32px">
				<SectionHeader direction="row" align={'flex-start'} gap="12px">
					<SectionTitle mb="0px" mbDesktop="0px">
						Reporte de Accesos{' '}
					</SectionTitle>
				</SectionHeader>
				{/* <SectionHeader align={'flex-start'}>
					<Text2 color={theme.colors.text.secondaryText}>Buscar por nombre, email o profesional </Text2>
				</SectionHeader> */}
				<FormContainer
					paddingMobile="0"
					maxWidth="100%"
					direction="row"
					align="start"
					justify="between"
					margin="0"
				>
					<InputsContainer>
						{/* <Input
							width={isMobile ? '100%' : '380px'}
							fullWidth
							name="string"
							placeholder="Buscar por nombre, email o profesional"
							onChange={handleSearch}
						/> */}
						<Button
							color={theme.colors.text.secondaryText}
							$variant={'cardNav'}
							iconLeft={<Filter />}
							label={'Filtros'}
							onClick={handleOpenFilters}
						/>
					</InputsContainer>
					{!isMobile && (
						<Button
							color={theme.colors.text.secondaryText}
							$variant={'primary'}
							iconLeft={<Download color={theme.colors.white} />}
							label={'Exportar excel'}
							onClick={handleExportExcel}
							disabled={excelDownloading || !dataList.length}
						/>
					)}
				</FormContainer>
			</Section>

			<Section>
				{isMobile ? (
					<ResultsList
						fields={logsFields}
						results={dataList}
						renderField={(field, result) => {
							if (field.key === 'nombreApellidoUsuario') {
								return (
									<MobileHeaderRow key={field.key}>
										<Text1 size={'16px'} color={theme.colors.text.primaryText} weight={600}>
											{result.nombreApellidoUsuario || '-'}
										</Text1>
										<Text1 size={'14px'} color={theme.colors.text.secondaryText}>
											{result.fechaHora || '-'}
										</Text1>
									</MobileHeaderRow>
								)
							}

							if (field.key === 'emailUsuario') {
								return (
									<Text1 key={field.key} size={'16px'} color={theme.colors.text.secondaryText}>
										{result.emailUsuario || '-'}
									</Text1>
								)
							}

							if (field.key === 'fechaHora') {
								return null
							}

							if (field.key === 'nombreAccion') {
								return (
									<LogText key={field.key}>
										<strong>Acción:</strong> {result.nombreAccion || '-'}
									</LogText>
								)
							}

							if (field.key === 'descripcion') {
								return (
									<LogText key={field.key}>
										<strong>Log:</strong> {result.descripcion || '-'}
									</LogText>
								)
							}

							return null
						}}
					/>
				) : (
					<ResultsListDesk isSearch={true} results={dataList} />
				)}
			</Section>
			<Pagination
				totalPages={pagination.totalPages}
				currentPage={pagination.currentPage}
				onPageChange={handlePageChange}
			/>
			<LogActionsFilterModal
				showModal={showFiltersModal}
				actions={auditActions}
				selectedActions={selectedFilters}
				onClose={() => setShowFiltersModal(false)}
				onApply={handleApplyFilters}
			/>
			{isMobile && (
				<SectionHeader align={'center'} direction="row">
					<Button
						width={'100%'}
						color={theme.colors.text.secondaryText}
						$variant={'primary'}
						label={'Exportar excel'}
						onClick={handleExportExcel}
						disabled={excelDownloading || !dataList.length}
					/>
				</SectionHeader>
			)}
		</div>
	)
}

const mapStateToProps = ({ filterLaboratory }) => ({
	filters: selectLabsFilters(filterLaboratory),
	filtersCount: selectLabsFiltersCount(filterLaboratory)
})

const mapDispatchToProps = {
	setLabsFilters,
	resetLabsFilters,
	showLoader,
	hideLoader,
	addFlashMessage
}

export default connect(mapStateToProps, mapDispatchToProps)(Logs)

const InputsContainer = styled.div`
	display: flex;
	gap: 12px;

	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		flex-wrap: wrap;
	}
`

const MobileHeaderRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 8px;
`

const LogText = styled(Text1)`
	font-size: 16px;
	color: ${props => props.theme.colors.text.secondaryText};
	white-space: pre-line;
`
